import { useLoginOrSignupPageState } from '#src/app/pages/loginOrSignup/pageContext';
import { isLoading } from '#src/app/shared/utils/async';

export function useCanSubmitForm(): boolean {
	const [{ currentStep, stepState, formErrors }] = useLoginOrSignupPageState();

	const loading = !!stepState && isLoading(stepState);

	if (currentStep !== 'login') {
		return !formErrors && !loading;
	}

	return !formErrors && !loading;
}
